<template>
  <div class="headbar">
    <div class="headbar__logo">
      <MenuButton @openNavigation="$event => $emit('openNavigation', $event)" />
      <h1 class="headbar__title">GLAD 測試2.0</h1>
    </div>
    <div class="headbar__user">
      <p>使用者：{{ user }}</p>
      <b-button @click="logout">登出<LogoutIcon /></b-button>
    </div>
  </div>
</template>

<script>
import Cookie from 'js-cookie';
import MenuButton from '@/components/commen/MenuButton';
import LogoutIcon from '@/assets/images/logout.svg';

export default {
  name: 'HeadBar',
  components: {
    MenuButton,
    LogoutIcon
  },
  methods: {
    logout() {
      Cookie.remove('token');
      this.$router.push({ name: 'Login' });
    }
  },
  computed: {
    user() {
      return Cookie.get('user');
    }
  }
};
</script>

<style lang="scss" scoped>
.headbar {
  position: fixed;
  z-index: 999;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: $bg-primary;
  padding: 20px 20px;
  border-bottom: 1px solid $border-gentle;
  color: $text-dark;

  &__logo {
    display: flex;
    align-items: center;
  }

  &__title {
    font-size: 20px;
    margin: 0;
  }

  &__user {
    display: flex;
    align-items: center;

    p {
      margin-right: 20px;
    }

    button {
      border: none;
      background-color: inherit;
      color: inherit;
      svg {
        width: 14px;
        margin-left: 5px;
        fill: $text-dark;
        transform: translateY(-2px);
      }
    }
  }
}
</style>
